"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformResponse = exports.transformNodeList = exports.queueNodes = void 0;
const axios_1 = __importDefault(require("axios"));
const network_enum_1 = require("./network.enum");
const chain_config_1 = require("../config/chain.config");
const queueNodes = async (nodesList, timeout = 1000) => {
    const startTime = Date.now();
    const heights = [];
    const sortedNodes = await Promise.all(nodesList.map((elem) => axios_1.default
        .request({
        url: `${elem.address}/api/node/status`,
        timeout,
        params: {
            node: elem.nodeId,
        },
    })
        .then((response) => {
        const url = new URL(response.config.url);
        const height = response?.data.status?.blockchain?.header?.height;
        heights.push(height);
        return {
            address: url.origin,
            time: Date.now() - startTime,
            nodeId: response.config?.params?.node,
            height,
        };
    }, (data) => {
        const url = new URL(data.config.url);
        return {
            address: url.origin,
            time: chain_config_1.config.maxNodeResponseTime,
            nodeId: data.config?.params?.node,
            height: 0,
        };
    })));
    const maxHeight = Math.max(...heights);
    const nodesWithMaxHeight = sortedNodes.filter((item) => item?.height && item?.height >= maxHeight - 3);
    return nodesWithMaxHeight.sort((a, b) => (a.time || 0) - (b.time || 0)); // TODO: default time
};
exports.queueNodes = queueNodes;
const transformNodeList = (rawNodes) => {
    const nodesList = [];
    const nodeIds = Object.keys(rawNodes);
    nodeIds.forEach((nodeId) => {
        rawNodes[nodeId].ip.forEach((address) => nodesList.push({ address, nodeId }));
        rawNodes[nodeId].host.forEach((address) => nodesList.push({ address, nodeId }));
    });
    return nodesList.reduce((acc, { address, nodeId }) => (acc.some((item) => item.address === address && item.nodeId === nodeId)
        ? acc // if address exists in acc - return acc
        : [...acc, { address, nodeId }]), // if address not exists - add it
    []);
};
exports.transformNodeList = transformNodeList;
const transformResponse = async (response, kind, requestParams) => {
    switch (kind) {
        case network_enum_1.ChainAction.GET_TRANSACTION_STATUS:
            return response.res;
        case network_enum_1.ChainAction.GET_CHAIN_NODES:
            return (0, exports.transformNodeList)(response.chain_nodes);
        case network_enum_1.ChainAction.GET_BLOCK:
            return response.block;
        case network_enum_1.ChainAction.GET_BLOCK_INFO:
            return response.block;
        case network_enum_1.ChainAction.GET_BLOCK_HASH:
            return response.blockhash;
        case network_enum_1.ChainAction.GET_WALLET:
            return { ...response.info, rawDataURL: `${requestParams.baseURL}/${requestParams.url}` };
        case network_enum_1.ChainAction.GET_NODE_SETTINGS:
            return response.settings;
        default:
            return response;
    }
};
exports.transformResponse = transformResponse;
